import { Controller } from 'stimulus'

export default class extends Controller {
	connect() {
		this.initSelect2()
	}

	initSelect2() {
		$(this.element).find('select.select2').each((_, select) => {
			const $select = $(select)
			this.cleanupSelect($select)

			const options = {}
			const $modal = $select.closest('.modal')
			if ($modal.length) {
				options.dropdownParent = $modal
			}

			// Keep blank options selectable in the dropdown. Select2 treats
			// empty-text options as placeholders and drops them from results.
			$select.find('option[value=""]').each((_, option) => {
				if (!(option.textContent || '').trim()) {
					option.textContent = '\u00A0'
				}
			})

			$select.select2(options)
			this.bindSelect2Events($select)
		})
	}

	cleanupSelect($select) {
		// Remove orphaned containers left behind by double-init or partial destroy
		let next = $select.next('.select2-container')
		while (next.length) {
			next.remove()
			next = $select.next('.select2-container')
		}

		$select.removeClass('select2-hidden-accessible')
		$select.removeAttr('data-select2-id aria-hidden tabindex')
	}

	bindSelect2Events($select) {
		$select.off('select2:select.filter select2:clear.filter select2:unselect.filter')
		$select.on('select2:select.filter select2:clear.filter select2:unselect.filter', (e) => {
			e.target.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}
}
